import gql from 'graphql-tag';

export const AUDIENCE_ENHANCEMENT_MUTATION = gql`
  mutation AudienceEnhancement(
    $articleId: ID!
    $minAudienceSize: Int!
    $maxAudienceSize: Int!
    $maxAudiencesToReturn: Int!
    $maxCreativesToReturn: Int!
  ) {
    audienceEnhancement(
      articleId: $articleId
      minAudienceSize: $minAudienceSize
      maxAudienceSize: $maxAudienceSize
      maxAudiencesToReturn: $maxAudiencesToReturn
      maxCreativesToReturn: $maxCreativesToReturn
    ) {
      seedInterestNames
      creatives {
        id
        iframe
      }
      audiences {
        audience {
          id
          description
          audienceSize
          audience
        }
        sources
      }
      errors
    }
  }
`;
